import CloseIcon from "@mui/icons-material/Close";
import type { SxProps, Theme } from "@mui/material";
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";

export default function DetailDialog({
  open,
  onClose,
  title,
  contentSx,
  children,
}: {
  open: boolean;
  onClose: () => void;
  title: React.ReactNode;
  contentSx?: SxProps<Theme>;
  children: React.ReactNode;
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      sx={{
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          backdropFilter: "blur(8px)",
        },
        "& .MuiDialog-container": {
          alignItems: { xs: "flex-start", sm: "center" },
        },
      }}
      slotProps={{
        paper: {
          sx: {
            width: { xs: "100vw", sm: "90vw" },
            height: {
              xs: "calc(100vh - 56px - env(safe-area-inset-bottom))",
              sm: "90vh",
            },
            maxWidth: { xs: "100vw", sm: "1200px" },
            maxHeight: {
              xs: "calc(100vh - 56px - env(safe-area-inset-bottom))",
              sm: "900px",
            },
            borderRadius: { xs: 0, sm: 3 },
            margin: { xs: 0, sm: 4 },
            overflow: "hidden",
          },
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 3,
          py: 2,
          pt: { xs: "calc(16px + env(safe-area-inset-top))", sm: 2 },
          borderBottom: "1px solid #F0F0F0",
          backgroundColor: "white",
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, fontSize: "1rem", color: "text.primary" }}
        >
          {title}
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            backgroundColor: "#F1EFF7",
            color: "#7D5DA3",
            "&:hover": { backgroundColor: "#E5E1F0" },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent sx={{ p: { xs: 2, sm: 3 }, ...contentSx }}>
        {children}
      </DialogContent>
    </Dialog>
  );
}
